import React from 'react';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from 'redux/store';
import { styles } from './styles';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { RoundRobinRoute } from "model/round-robin-route";
import { Avatar } from "component/shared/avatar";
import { FeatherIcon } from "component/shared/feather-icon";
import * as Icons from "react-feather";
import { AppCard } from "component/shared/app-card";

interface Props extends OwnProps,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {}

interface OwnProps {
	roundRobinRoute: RoundRobinRoute;
	position: number;
	onDelete: () => void;
}

interface State {
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
	return {
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators({
	}, dispatch);
};

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
		};
	}

	render() {
		const { classes = {}, position, roundRobinRoute, onDelete } = this.props;
		return (
			<AppCard className={classes.cardContent}><Mui.CardContent>																			
					<Mui.Grid container direction="row" spacing={1} alignItems="center">
						<Mui.Grid item>
							<DragIndicatorIcon />
						</Mui.Grid>
						<Mui.Grid item>
							<Mui.Box display="flex" alignItems="center" flexDirection="row">
								<Avatar 
									phrase={roundRobinRoute.agent.label} 
									src={roundRobinRoute.agent.photoUrl} 
								/>
								<Mui.Typography className={classes.agentLabel} >
									{roundRobinRoute.agent.label}
								</Mui.Typography>
							</Mui.Box>
						</Mui.Grid>
						<Mui.Grid item className={classes.positionItem}>
							<Mui.Chip label={position} size="small" className={classes.position} />
						</Mui.Grid>
						<Mui.Grid item className={classes.deleteItem}>
							<Mui.Tooltip title="Remove Agent from Rotation">
								<Mui.IconButton
									onClick={() => window.confirm(`Remove ${roundRobinRoute.agent.label} from the rotation?`) && onDelete()}
									className="actions"
								>
									<FeatherIcon>
										<Icons.Trash />
									</FeatherIcon>
								</Mui.IconButton>
							</Mui.Tooltip>
						</Mui.Grid>
					</Mui.Grid>
			</Mui.CardContent></AppCard>
		);
	}
}

export const Card = withStyles(connect(mapStateToProps, mapDispatchToProps)(Component), styles);